import React from 'react';
import './Testimonials.css';

const Testimonials: React.FC = () => {
  const testimonials = [
    {
      name: 'Elena Tuttle',
      location: 'Tustin',
      review: '"Above and beyond. We had a very complex 1031 exchange and multiple mortgages with multiple entities. Stephan and his team worked tirelessly to ensure we closed on our properties"'
    },
    {
      name: 'Dan May',
      location: 'Costa Mesa',
      review: '"My go to resource for everything mortgage related. Prompt service, valuable experience, competitive pricing.  Highly recommend.  You owe it to yourself and family to use The Best!"'
    },
    {
      name: 'Agent Ivy',
      location: 'Irvine',
      review: '"His strategic helped us procure a good loan at the best available rate. He took an interest in my concerns and my fears and offered me incredibly kind and helpful feedback."'
    }
  ];

  return (
    <section className="testimonials-section">
      <div className="testimonials-wrapper">
        {testimonials.map((testimonial, index) => (
          <div key={index} className="testimonial-card">
            <div className="testimonial-divider"></div>
            <div className="testimonial-content">
              <div className="star-rating">
                {[...Array(5)].map((_, i) => (
                  <svg key={i} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M11.9996 17.8441L6.18281 20.9021L7.29371 14.4251L2.58786 9.838L9.09119 8.89301L11.9996 3L14.9079 8.89301L21.4113 9.838L16.7054 14.4251L17.8163 20.9021L11.9996 17.8441Z" fill="#0578EC" stroke="#0578EC" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                ))}
              </div>
              <div className="reviewer-name">
                <strong>{testimonial.name}</strong> from {testimonial.location}
              </div>
              <p className="review-text">
                {testimonial.review}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
